/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable array-callback-return */
/* eslint-disable max-len */
import TransitDivider from '@/components/TransitDivider';
import TripCardDetailContent from '@/components/TripCardDetailContent';
import { style } from '@/styles/globals';
import { extractFareRule } from '@/utils/extractFareRule';
import { getMappingDataFromSegments } from '@/utils/flightCardMapping';
import { pr } from '@/utils/pxToRem';
import { getTotalDiscountAmount } from '@/utils/tripMapping';
import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { format } from 'date-fns';
import {
  get, isEmpty, reduce, uniqueId,
} from 'lodash';
import { useRouter } from 'next/router';
import React, { useCallback, useMemo, useState } from 'react';
import { useAppSelector } from '../../utils/hook';
import TripDetailListAddons from '../TripDetailListAddons';

const ContentWrapper = styled('div')(({ theme }) => ({
  padding: theme.palette.medium,
  background: theme.palette.white,
}));

interface TripCardDetailProps {
  isDepart?: boolean;
  isDesktop?: boolean;
  isReturn?: boolean;
  isExpandedDefault?: boolean;
  isHideDetail?: boolean;
  selectedFlightProps?: any;
}

const TripCardDetail: React.FC<TripCardDetailProps> = (
  props: TripCardDetailProps,
) => {
  const {
    isDepart, isReturn, isExpandedDefault, isHideDetail, isDesktop, selectedFlightProps,
  } = props;

  const chooseReturn = useAppSelector((state) => state.calendar.chooseReturn);

  const seatClass = useAppSelector((state) => state.searchFlightForm.seatClass);
  const selectedDate = useAppSelector((state) => state.calendar.selectedDate);

  const returnFlight = useAppSelector(
    (state) => state.selectedFlight.returnFlight,
  );
  const departFlight = useAppSelector((state) => state.selectedFlight.flight);

  const selectedFlight = selectedFlightProps || (isReturn && returnFlight ? returnFlight : departFlight);

  const segmentsData = useMemo(
    () => getMappingDataFromSegments(selectedFlight!),
    [selectedFlight],
  );

  const isTransit = segmentsData.length > 1;
  const isRoundTrip = chooseReturn;

  const isDetailObj: any = {};
  segmentsData.map((_, index) => {
    if (isTransit) {
      isDetailObj[index.toString()] = false;
      return;
    }
    if (index === segmentsData.length - 1 && !isExpandedDefault) {
      if (isRoundTrip) {
        if (returnFlight) {
          if (isDepart) {
            isDetailObj[index.toString()] = false;
          } else {
            isDetailObj[index.toString()] = true;
          }
        } else {
          isDetailObj[index.toString()] = true;
        }
      } else {
        isDetailObj[index.toString()] = true;
      }
    } else {
      isDetailObj[index.toString()] = false;
    }
  });
  const [isDetail, setIsDetail] = useState(isDetailObj);

  const handleExpandChange = useCallback((index: number) => {
    setIsDetail((prevState: any) => {
      const newState = { ...prevState };
      newState[index] = !newState[index];
      return newState;
    });
  }, []);

  const duration = (selectedFlight?.segments[1]
    ? Math.max(
      selectedFlight.segments[0].duration,
      selectedFlight.segments[1].duration,
    )
    : selectedFlight?.segments[0].duration) || selectedFlight?.duration;

  const { push } = useRouter();

  const discountAmount = useAppSelector((state) => state.selectedFlight.discountAmount);
  const returnDiscountAmount = useAppSelector((state) => state.selectedFlight.returnDiscountAmount);
  const passenger = useAppSelector((state) => state.searchFlightForm.passenger);

  const handleRule = (type: 'refund' | 'update') => () => {
    const totalDiscountAmount = getTotalDiscountAmount(discountAmount + returnDiscountAmount, passenger);
    if (isReturn && returnFlight) {
      const totalPrice = reduce(returnFlight?.route?.schedules, (sum, x) => sum + x?.totalPriceAdult, 0) - totalDiscountAmount;
      const dateExpire = format(new Date(returnFlight?.route?.departureDate), 'yyyy/MM/dd');
      const timeExpire = returnFlight?.route?.departureTime;
      push(`/ticket-policy?type=${type}&airline=${returnFlight?.airline}&expireDate=${dateExpire}&expireTime=${timeExpire}&totalPrice=${totalPrice}&fareClass=${returnFlight?.segments?.[0]?.class}&operatingAirline=${returnFlight?.segments?.[0]?.operatingAirline}&cabin=${returnFlight?.segments?.[0]?.cabin}`);
    }
    if (isDepart && departFlight) {
      const totalPrice = reduce(departFlight?.route?.schedules, (sum, x) => sum + x?.totalPriceAdult, 0) - totalDiscountAmount;
      const dateExpire = format(new Date(departFlight?.route?.departureDate), 'yyyy/MM/dd');
      const timeExpire = departFlight?.route?.departureTime;
      push(`/ticket-policy?type=${type}&airline=${departFlight?.airline}&expireDate=${dateExpire}&expireTime=${timeExpire}&totalPrice=${totalPrice}&fareClass=${departFlight?.segments?.[0]?.class}&operatingAirline=${departFlight?.segments?.[0]?.operatingAirline}&cabin=${departFlight?.segments?.[0]?.cabin}`);
    }
  };
  let fareRule = {} as any;
  if (selectedFlight && selectedFlight.fareRules) {
    const operatingAirline = get(selectedFlight, 'segments[0].operatingAirline') || selectedFlight.airline || '';
    const checkingDate = selectedFlight.date;
    fareRule = extractFareRule(
      {
        fareRules: selectedFlight.fareRules,
        checkingDateStr: checkingDate,
        operatingAirline,
        endPoint: selectedFlight.endPoint,
        toPoint: selectedFlight.startPoint,
        seatClass: selectedFlight?.segments?.[0]?.class || '',
        cabin: selectedFlight?.segments?.[0]?.cabin || '',
      },
    );
  }
  return (
    <ContentWrapper>
      {isDesktop && isDepart && (
      <Typography
        variant="title"
        component="div"
        sx={{ mb: pr`24px` }}
        color={style.color.black1}
      >
        Thông tin chuyến bay
      </Typography>
      )}
      <Stack spacing={pr`16px`}>
        {segmentsData.map((segment, index) => (
          <Stack
            key={uniqueId()}
            spacing={pr`16px`}
          >
            <Stack>
              <TripCardDetailContent
                isDesktop={isDesktop}
                segmentData={segment}
                isDepart={isDepart}
                isTransit={segmentsData.length > 1}
                isRoundTrip={isRoundTrip}
                isReturn={isReturn}
                canExpanded={!isHideDetail}
                isHideDateHeader={index > 0}
                onExpandChange={() => handleExpandChange(index)}
                isExpanded={isDetail[index]}
                seatClass={seatClass}
                selectedDate={selectedDate}
                cabin={segment?.[0]?.cabin}
                startTerminal={segment.startTerminal}
                endTerminal={segment.endTerminal}
              />
              {!isHideDetail && !isEmpty(fareRule) && (
                <Stack
                  sx={{
                    maxHeight: isDetail[index] ? '800px' : 0,
                    overflow: 'hidden',
                    transition: '0.5s',
                  }}
                >
                  <TripDetailListAddons
                    selectedFlightProps={selectedFlight}
                    duration={duration || 0}
                    fareRule={fareRule}
                    onViewRefundRule={handleRule('refund')}
                    onViewUpdateRule={handleRule('update')}
                  />
                </Stack>
              )}
            </Stack>
            {segmentsData[index + 1] && (
              <TransitDivider
                duration={segment.stopDuration}
                airportName={segment.arrivalAirportName}
              />
            )}
          </Stack>
        ))}
      </Stack>
    </ContentWrapper>
  );
};

export default TripCardDetail;
